import React,{useContext, useEffect, useState} from 'react';
import { Contextone } from "./Context.jsx";
import {fetchGeneralSetting } from "./Api";
import 'bootstrap/dist/css/bootstrap.min.css';
import gpLogo from '../images/googlePlayIcon.png';
import appStore from '../images/appStoreIcon.png';

const Download = () => {
  
  const [isSetting, setSetting] = useState([])
  const [isPlayStoreLink, setPlayStoreLink] = useState("");
  const [isAppStoreLink, setAppStoreLink] = useState("");
  const counterContext = useContext(Contextone);
  const isurl = counterContext.isDomain;
  const apiUrl = `https://${isurl}`;
  
  
  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const data = await fetchGeneralSetting(apiUrl);
        setSetting(data.result);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchSetting();
  }, [isurl]);

  useEffect(() => {
    if (Array.isArray(isSetting)) {
      isSetting.forEach((mtype, index) => {
        if(mtype.key === 'playstore_link' && mtype.value !== ''){
          setPlayStoreLink(mtype.value)
        }
        if(mtype.key === 'appstore_link' && mtype.value !== ''){
          setAppStoreLink(mtype.value)
        }
      });
    }
  }, [isSetting]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ backgroundColor: 'white', height: '100vh' }}>
      <div className="bg-light p-4 rounded text-center" style={{ width: '100%', maxWidth: '600px' }}>
        <h2 className="mb-3">Download it now.</h2>
        <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center mb-3">
          <a href={isPlayStoreLink} target="_blank" rel="noopener noreferrer" className="btn btn-dark mx-2 my-2 my-sm-0">
            <img src={gpLogo} alt="Google Play" width="20" style={{ marginRight: '5px' }} />
            Google Play
          </a>
          <a href={isAppStoreLink} target="_blank" rel="noopener noreferrer" className="btn btn-dark mx-2 my-2 my-sm-0">
            <img src={appStore} alt="App Store" width="20" style={{ marginRight: '5px' }} />
            App Store
          </a>
        </div>
      </div>
    </div>
  );
}

export default Download;